import {BulkRewardFailedEmails, User} from "@irati/types"
import CSVErrors from "../../enums/CsvErrors"
import {DistributeRewardImportType, DistributeRewardRecipient} from "../../enums/DistributeRewardTypes"

export interface UserRecognition {
  companyValues: string[],
  message: string,
  userIds: string[],
  teamIds: string[],
  isPrivate: boolean,
  share: { label: string, value: string }
}

export enum DistributeRewardActions {
  SWITCH_RECIPIENT = "SWITCH_RECIPIENT",
  UPDATE_RECIPIENTS = "UPDATE_RECIPIENTS",
  SWITCH_IMPORT_TYPE = "SWITCH_IMPORT_TYPE",
  SET_USER_POINTS = "SET_USER_POINTS",
  SET_MESSAGE = "SET_MESSAGE",
  SET_RECOGNITION = "SET_RECOGNITION",
  SET_MODAL_ERROR_STATE = "SET_MODAL_ERROR_STATE",
  SET_BULK_REWARD_STATE = "SET_BULK_REWARD_STATE",
  ON_ACCEPT_EMAIL_ERRORS = "ON_ACCEPT_EMAIL_ERRORS",
  ON_REJECT_EMAIL_ERRORS = "ON_REJECT_EMAIL_ERRORS"
}
export interface DistributeRewardState {
  pointsPerUser: number,
  message: string,
  destinationUsers: User[],
  userEmails: string[],
  recipientType: DistributeRewardRecipient,
  rewardImportType: DistributeRewardImportType,
  recognition: UserRecognition,
  bulkRewardState: BulkRewardState,
  modalErrorState: ModalErrorState
}

export type DistributeOnChange = (payload: DistributeRewardState) => void
export type BulkRewardState = {
  failedEmails: BulkRewardFailedEmails[],
  uuid: string | null,
  csvError: CSVErrors | null
}
export type ModalErrorState = {
  title: string,
  content: string,
  buttonText: string,
  show: boolean
}
export type SwitchRecipientPayload = {
  recipientType: DistributeRewardRecipient
}
export type UpdateRecipientsPayload = {
  recipientsList: User[] | string[]
}
export type UpdateImportTypePayload = {
  importType: DistributeRewardImportType
}
export type SetHandleUserPointsPayload = {
  userPoints: string
}
export type SetMessagePayload = {
  message: string
}
export type SetRecognitionPayload = {
  recognition: UserRecognition
}
export type SetModalErrorStatePayload = {
  title: string,
  content: string,
  buttonText: string,
  show: boolean
}
export type SetBulkRewardPayload = {
  failedEmails?: BulkRewardFailedEmails[],
  uuid?: string | null,
  csvError?: CSVErrors | null
}

export type ActionsPayloads = SwitchRecipientPayload & UpdateRecipientsPayload &
  UpdateImportTypePayload & SetHandleUserPointsPayload &
  SetMessagePayload & SetRecognitionPayload & SetBulkRewardPayload & SetModalErrorStatePayload

export type DistributeRewardActionTypes =
  | {
  type: DistributeRewardActions.SWITCH_RECIPIENT,
  payload: SwitchRecipientPayload
}
  | {
  type: DistributeRewardActions.UPDATE_RECIPIENTS,
  payload: UpdateRecipientsPayload
}
  | {
  type: DistributeRewardActions.SWITCH_IMPORT_TYPE,
  payload: UpdateImportTypePayload
}
  | {
  type: DistributeRewardActions.SET_USER_POINTS,
  payload: SetHandleUserPointsPayload
}
  | {
  type: DistributeRewardActions.SET_MESSAGE,
  payload: SetMessagePayload
}
  | {
  type: DistributeRewardActions.SET_RECOGNITION,
  payload: SetRecognitionPayload
} | {
  type: DistributeRewardActions.SET_MODAL_ERROR_STATE,
  payload: SetModalErrorStatePayload
} | {
  type: DistributeRewardActions.SET_BULK_REWARD_STATE,
  payload: SetBulkRewardPayload
} | {
  type: DistributeRewardActions.ON_ACCEPT_EMAIL_ERRORS
} | {
  type: DistributeRewardActions.ON_REJECT_EMAIL_ERRORS
}
